// OffscreenCanvas with HTMLCanvasElement fallback (Plan v2 G3).
//
// OffscreenCanvas keeps decoding/encoding off the main thread on supported
// browsers (Chrome 69+, Safari 16.4+, Firefox 105+). The transferToImageBitmap
// probe filters out partial implementations that ship the constructor but not
// the worker-transfer surface (e.g. older Safari TP builds).

export function makeCanvas(width: number, height: number): OffscreenCanvas | HTMLCanvasElement {
  if (
    typeof OffscreenCanvas !== 'undefined' &&
    typeof OffscreenCanvas.prototype.transferToImageBitmap === 'function'
  ) {
    return new OffscreenCanvas(width, height)
  }
  const c = document.createElement('canvas')
  c.width = width
  c.height = height
  return c
}

export async function canvasToBlob(
  canvas: OffscreenCanvas | HTMLCanvasElement,
  format: 'image/webp' | 'image/jpeg' = 'image/webp',
  quality = 0.78,
): Promise<Blob> {
  // The typeof guard keeps `instanceof OffscreenCanvas` safe in environments
  // where the global isn't defined (older Safari, happy-dom test env).
  if (typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) {
    return canvas.convertToBlob({ type: format, quality })
  }
  return new Promise((resolve, reject) => {
    ;(canvas as HTMLCanvasElement).toBlob(
      (b) => (b ? resolve(b) : reject(new Error('canvas.toBlob returned null'))),
      format,
      quality,
    )
  })
}
